import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import loader from "../../assets/loader.json";
// import Navbar from "../../Components/Navbar";
import { DataGrid } from "@mui/x-data-grid";
import { styles } from "../../styles/style";
import { FiDownload, FiEye } from "react-icons/fi";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";

const TranctionH = ({ id, transactions = [], isLoading = false }) => {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (Array.isArray(transactions) && transactions.length > 0) {
      setRows(
        transactions.map((item, index) => {
          const date = new Date(item.date || item.createdAt || Date.now()).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });
          return {
            id: index + 1,
            _id: item._id,
            date,
            currency: item.currency,
            amount: item.amount,
            fee: item.fee || 0,
            ordertype: item.ordertype || "N/A",
            transferid: item.transferid || "N/A",
            email: item.email || "N/A"
          };
        })
      );
    } else {
      setRows([]);
    }
  }, [transactions]);

  const columns = [
    { field: "id", headerName: "S.No", flex: 0.2, minWidth: 50 },
    { field: "date", headerName: "Date", flex: 0.8, minWidth: 150 },
    { field: "currency", headerName: "Symbol", flex: 0.5, minWidth: 100 },
    { field: "amount", headerName: "Amount", flex: 0.5, minWidth: 100 },
    { field: "ordertype", headerName: "Order Type", flex: 0.5, minWidth: 100 },
    { field: "transferid", headerName: "Transfer ID", flex: 0.8, minWidth: 150 },
  ];

  const style = {
    height: 100,
    width: 100,
    margin: "auto",
    alignItem: "center",
  };

  const handleExport = () => {
    if (!rows.length) return;
    const exportRows = rows.map((row) => ({
      "S.No": row.id,
      "Date": row.date,
      "Currency": row.currency,
      "Amount": row.amount,
      "Fee": row.fee,
      "Order Type": row.ordertype,
      "Transfer ID": row.transferid,
      "Email": row.email,
    }));
    const ws = XLSX.utils.json_to_sheet(exportRows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Transaction History");
    XLSX.writeFile(wb, `Transaction_History_${id || "user"}.xlsx`);
  };

  return (
    <>
      {/* <Navbar /> */}
      {isLoading ? (
        <Lottie animationData={loader} style={style} loop={true} width={20} />
      ) : (
        <div className="w-[80vw] mx-auto h-full">
          <div className="w-full mt-[10px] border">
            <div className="flex justify-between p-5 text-blue-900 font-bold">
              <h1 className="text-2xl">Transaction History</h1>
              <button
                onClick={handleExport}
                className="flex items-center gap-2 px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded shadow text-sm"
              >
                <FiDownload className="w-5 h-5" />
                {/* Export */}
              </button>
            </div>
            <DataGrid columns={columns} rows={rows} autoHeight />
          </div>
        </div>
      )}
    </>
  );
};

export default TranctionH;
